// I'm keeping this file as we are going to use Graph API in teh following weeks for impersonation page
// Currently this is dorman code thats why we have soem hardcoded things like Het's email
import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import authService from '../../../services/auth/service-auth';
import AppEnvironment from '../../../environment/app-environment';

const urlCreator = window.URL || window.webkitURL;

export const graphApiDuck = createApi({
  reducerPath: 'APIGraph',
  baseQuery: fetchBaseQuery({
    baseUrl: AppEnvironment.graphEndpoint,
    async prepareHeaders(headers) {
      let bearerToken;
      try {
        bearerToken = await authService.getHeaderForScope(authService.GRAPH_AUTH_SCOPE);
      } catch {
        bearerToken = '';
      }
      headers.append('authorization', bearerToken);
      headers.append('Content-Type', 'image/jpeg');
      return headers; // pending
    },
  }),
  endpoints(builder) {
    return {
      getPhoto: builder.query<string, string>({
        query: (alias) => ({
          url: `users/${alias}@${AppEnvironment.graphDomain}/photo/$value`,
          responseHandler: async (response) => urlCreator.createObjectURL(await response.blob()),
        }),
      }),
    };
  },
});

export const { useGetPhotoQuery } = graphApiDuck;
